import { Form, Rate } from "antd";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../apis/store";
import { toAddReview, toGetDetails } from "../../apis/actions/service.actions";
import { showNotitfication } from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import DetailCollapseSection from "./DetailCollapseSection";

interface AddReviewProps {
  id: number;
  sectionId: string;
  isOpen: boolean;
  onToggle: (id: string) => void;
  isRtl?: boolean;
  onReviewSubmitted?: () => void | Promise<void>;
}

const AddReview = ({
  id,
  sectionId,
  isOpen,
  onToggle,
  isRtl = false,
  onReviewSubmitted,
}: AddReviewProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();

  const handleApply = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const applyData = {
        ...values,
        product_id: id,
      };

      const success = (await dispatch(toAddReview(applyData))) as any;
      const review = success?.payload?.data?.result;

      if (review?.code === 200) {
        showNotitfication(review?.message, "success");
        if (onReviewSubmitted) {
          await onReviewSubmitted();
        } else {
          await dispatch(toGetDetails({ id, lang: i18n.language }));
        }
        form.resetFields();
      } else {
        showNotitfication(review?.message, "error");
      }
    } catch {
      /* validation */
    }
  };

  const desc = ["Terrible", "Bad", "Normal", "Good", "Wonderful"];

  const icon = (
    <svg viewBox="0 0 20 20" fill="none" width="18" height="18">
      <path
        d="M12 4v12M4 12h16"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );

  return (
    <DetailCollapseSection
      sectionId={sectionId}
      title={t("menu.addReview")}
      icon={icon}
      isOpen={isOpen}
      onToggle={onToggle}
      isRtl={isRtl}
    >
      <div className="ac-shop-detail__add-review">
        <p className="ac-shop-detail__add-review-lead">
          {t("review.feedback")}
        </p>
        <Form form={form} layout="vertical" className="ac-shop-detail__review-form">
          <Form.Item name="rate" rules={[{ required: true }]}>
            <Rate tooltips={desc} allowClear />
          </Form.Item>
          <Form.Item name="message" rules={[{ required: true }]}>
            <textarea
              className="form-control ac-shop-detail__review-textarea ac--expo-font"
              placeholder={t("review.comment")}
              rows={4}
            />
          </Form.Item>
          <button
            type="button"
            className="ac-shop-detail__cta btn"
            onClick={handleApply}
          >
            {t("review.submit")}
            {i18n.language === "ar" ? (
              <FaArrowLeft aria-hidden />
            ) : (
              <FaArrowRight aria-hidden />
            )}
          </button>
        </Form>
      </div>
    </DetailCollapseSection>
  );
};

export default AddReview;
